module.exports = __webpack_public_path__ + "static/media/portfolio.ffc51afe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/portfolio.svg
// module id = 290
// module chunks = 0